import { AbstractControl, ValidationErrors } from "@angular/forms";
import { CustomValidator } from "experian-design-system";

export class AlphanumericRegexValidator extends CustomValidator {

  private key: string;
  private message: string;
  private readonly regex = /^[a-zA-Z0-9\s]+$/;

  constructor(key: string, message: string) {
    super();
    this.key = key;
    this.message = message;
  }

  protected isValid(control: AbstractControl): boolean {
    if (this.regex.test(control.value) ) {
      return true;
    }

    return false;
  }

  protected errorValidator(): ValidationErrors {
    return {
      [this.key]: this.message
    };
  }
}
